import React from 'react'
import { Image } from 'react-native'

import { useB2C } from '@zet/common/hooks/useB2C'
import { B2, BottomSheet, Button, H5, Icon, SH1 } from '@zet/design-system'
import { Stack, XStack } from '@zet/design-system/layout'
import colors from '@zet/design-system/tailwind/colors'
import { i18n } from '@zet/localization'

import useRecommendationsFlatlistRef from '../../hooks/useRecommendationsFlatlistRef'
import { getApprovalRateState } from '../../utils'
import {
  MAGNET_CARD_PROMOTION_URL,
  NAVIGATE_TO_MAGNET_CARD_SCREEN_WEBVIEW_EVENT,
  REFRESH_PAGE_WEBVIEW_EVENT,
} from '../../utils/constants'

type ExploreOtherEligibleCardBSProps = {
  snapPoints?:
    | Array<number>
    | ((minHeight: number, maxHeight: number) => Array<number>)
  isVisible: boolean
  eligibleCardsCountExcludingMagnet?: number
  approvalRate?: {
    approvalRateTextColor?: 'HIGH' | 'MEDIUM'
    approvalRateText?: string
    highApproval?: boolean
  }
  setIsVisible: React.Dispatch<React.SetStateAction<boolean>>
  setIsBrandDetailsBSVisible: React.Dispatch<React.SetStateAction<boolean>>
}

const ExploreOtherEligibleCardBS = ({
  snapPoints,
  isVisible,
  setIsVisible,
  approvalRate,
  eligibleCardsCountExcludingMagnet,
  setIsBrandDetailsBSVisible,
}: ExploreOtherEligibleCardBSProps) => {
  const { hasMagnetCard } = useB2C()
  const recommendationsFlatlistRef = useRecommendationsFlatlistRef()

  const approvalRateState = getApprovalRateState({
    approvalRate: approvalRate?.approvalRateTextColor,
    approvalRateText: approvalRate?.approvalRateText,
  })

  const hideBottomSheet = () => {
    setIsVisible(false)
    setIsBrandDetailsBSVisible(false)
  }

  const onPressCTA = () => {
    hideBottomSheet()

    if (Number(eligibleCardsCountExcludingMagnet) > 0) {
      setTimeout(
        () =>
          recommendationsFlatlistRef?.current?.scrollToIndex({
            animated: true,
            index: 0,
          }),
        50
      )
      window?.ReactNativeWebView?.postMessage(REFRESH_PAGE_WEBVIEW_EVENT)
    } else if (!hasMagnetCard) {
      window?.ReactNativeWebView?.postMessage(
        NAVIGATE_TO_MAGNET_CARD_SCREEN_WEBVIEW_EVENT
      )
    }
  }

  if (isVisible) {
    return (
      <BottomSheet
        visible={isVisible}
        disableBottomSheet={hideBottomSheet}
        snapPoints={snapPoints}
        onDismiss={hideBottomSheet}
        sheetName="Viewed_ineligible_bottomsheet"
        eventPayload={{
          hasMagnet: hasMagnetCard,
          hasOtherEligibleUnsecuredCard: eligibleCardsCountExcludingMagnet,
        }}
        footer={
          <Button
            size="lg"
            fullWidth
            className="w-full self-center rounded-full"
            onPress={onPressCTA}
          >
            {Number(eligibleCardsCountExcludingMagnet) > 0
              ? 'Explore Other Eligible Cards'
              : !hasMagnetCard
              ? 'Explore Magnet'
              : 'Okay'}
          </Button>
        }
      >
        <Stack className="mt-4/2 mb-6 items-center justify-center px-3">
          <Stack className="items-center justify-center rounded-full bg-[#FFE3E3] p-2">
            <Icon type="CautionFilled" color={colors.error[100]} />
          </Stack>
          <H5 className="mt-2">{approvalRateState?.text}</H5>
          <B2 className="mt-2 text-center">
            {i18n.t('exploreOtherEligibleCardBS.ineligibleCardsApprovalChance')}{' '}
            {Number(eligibleCardsCountExcludingMagnet) > 0
              ? i18n.t('exploreOtherEligibleCardBS.otherCardsApprovalChance')
              : !hasMagnetCard
              ? i18n.t('exploreOtherEligibleCardBS.magnetCardApprovalChance')
              : ''}
          </B2>
          {!(Number(eligibleCardsCountExcludingMagnet) > 0) &&
            !hasMagnetCard && (
              <Stack>
                <XStack className="mt-5 ">
                  <Icon type="IncreaseHighGrowth" />
                  <SH1 className="ml-2">
                    {i18n.t('exploreOtherEligibleCardBS.cardWithHighApproval')}
                  </SH1>
                </XStack>

                <Image
                  source={{
                    uri: MAGNET_CARD_PROMOTION_URL,
                  }}
                  resizeMode="center"
                  className="mt-4/2 rounded-xl"
                  style={{
                    height: 232,
                    width: 312,
                  }}
                />
              </Stack>
            )}
        </Stack>
      </BottomSheet>
    )
  }

  return <></>
}

export default ExploreOtherEligibleCardBS
